export var ArmorClassTypeEnum;
(function (ArmorClassTypeEnum) {
    ArmorClassTypeEnum["ARMOR"] = "Armor";
    ArmorClassTypeEnum["SHIELD"] = "Shield";
    ArmorClassTypeEnum["DEX_BONUS"] = "Dexterity Bonus";
    ArmorClassTypeEnum["MAGIC_BONUS"] = "Magic Bonus";
    ArmorClassTypeEnum["MISC_BONUS"] = "Misc Bonus";
    ArmorClassTypeEnum["UNARMORED_BONUS"] = "Unarmored Bonus";
    ArmorClassTypeEnum["ARMORED_BONUS"] = "Armored Bonus";
    ArmorClassTypeEnum["OVERRIDE_BASE_ARMOR"] = "Base Armor + DEX (Override)";
})(ArmorClassTypeEnum || (ArmorClassTypeEnum = {}));
export var ArmorClassExtraTypeEnum;
(function (ArmorClassExtraTypeEnum) {
    ArmorClassExtraTypeEnum["MODIFIER"] = "MODIFIER";
    ArmorClassExtraTypeEnum["ITEM"] = "ITEM";
    ArmorClassExtraTypeEnum["STRING"] = "STRING";
    ArmorClassExtraTypeEnum["NUMBER"] = "NUMBER";
})(ArmorClassExtraTypeEnum || (ArmorClassExtraTypeEnum = {}));
